/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var DEFAULT_SUBMENU_PADDING_LEFT = 44;
var INCREASE_SUBMENU_PADDING_LEFT = 16;
var cacularPaddingLeft = function cacularPaddingLeft(level) {
  return DEFAULT_SUBMENU_PADDING_LEFT + level * INCREASE_SUBMENU_PADDING_LEFT;
};

export { cacularPaddingLeft };
//# sourceMappingURL=cacularPaddingLeft.js.map
